import { MyContext } from "../../pages/Funnel";
import React, { useContext, useEffect, useState } from "react";

const Timer = () => {
  let [hours, setHours] = useState(2);
  let [minutes, setMinutes] = useState(9);
  let [seconds, setSeconds] = useState(59);
  const { state } = useContext(MyContext);

  useEffect(() => {
    let TimingFunction = setInterval(() => {
      if (seconds < 1) {
        setSeconds(59);
        setMinutes(minutes - 1);
        if (minutes < 1) {
          setMinutes(9);
          window.open(state.razor);
          setHours(hours - 1);
          return;
        }
      } else {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => clearInterval(TimingFunction);
  }, [seconds, minutes, hours]);

  return (
    <div>
      <div className="my-5 space-x-3 m-auto flex items-center text-center justify-center ">
        <span
          style={{ backgroundColor: state.color }}
          className="rounded-[50%] w-10 h-10 bg-primary inline-block text-white p-2 text-sm relative max-sm:text:xs">
          <p className="absolute top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4">
            00h
          </p>
        </span>
        <span className="font-black text-xl">:</span>
        <span
          style={{ backgroundColor: state.color }}
          className="rounded-[50%] w-10 h-10 bg-primary inline-block text-white p-2 text-sm relative max-sm:text:xs">
          <p className="absolute top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 ">
            {minutes}m
          </p>
        </span>
        <span className="font-black text-xl">:</span>
        <span
          style={{ backgroundColor: state.color }}
          className="rounded-[50%] w-10 h-10 bg-primary inline-block text-white p-2 text-sm relative max-sm:text:xs">
          <p className="absolute top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4 ">
            {seconds}s
          </p>
        </span>
      </div>
    </div>
  );
};

export default Timer;
